<template>
  <div class="registration" v-if="model.title != null">
    <vue-title :title="model.title"></vue-title>
    <h1 class="section-title">{{ model.title }}</h1>
    <form ref="form" @submit.prevent="validateBeforeSubmit">
      <div v-if="model.showError">
        <div class="validation-summary-errors alert alert-danger fade show" role="alert" data-valmsg-summary="true" data-test-element="idp-alert-danger-generic">
          <i class="material-icons">warning</i>
          <span>{{ model.errorMessage }}</span>
        </div>
        <button type="button" v-on:click="loginCancel(cancelLink)" name="Action:RedirectToLogin" class="button" :disabled="disabled">{{ $t('shared:action:back') }}</button>
      </div>
      <div v-else>
        <fieldset>
          <div class="panel-message" v-html="model.instructions">
          </div>
          <div :class="{'mb-4': model.isAddNewPhoneEnabled}">
            <label>
              <span class="item label">{{ $t('identityProvider:login:setupOTPSelectPhone') }}</span>
            </label>
            <div class="form-group" v-for="(option,index) in model.availablePhoneNumbers">
              <input type="radio" class="mr-1" name="phoneNumber" :value="option.phoneNumber" :id="parseInt(option.countryCodeID) > 1 ? option.countryCodeID : '1'" :data-id="option.countryCode" :data-pid="option.id" :data-forsms="option.registeredForSMS" :checked="index == 0" @change="ddlBindPhoneNumber()" />
              <label class="displayInline" :for="option.id"> +{{ option.countryCode }} {{ option.phoneNumber }}</label>
            </div>
            <div v-if="model.isAddNewPhoneEnabled && model.phoneComplexity !== null">
              <input type="radio" class="mr-1" id="addnewradio" name="phoneNumber" @change="txtBindPhoneNumber()">
              <select id="ddlCountryCode" class="control countryCode displayInline" disabled>
                <option :value="country.countryCodeID" :data-id="country.countryCode" v-for="country in model.countries" v-html="returnCountryCodeAndCountryName(country.countryCode , country.countryName)"></option>
              </select>
              <input type="text" id="txtPhoneNumber" name="phoneNo" class="control input-text displayInline" disabled v-model="insertmodel.phoneNumber" placeholder="XXX XXX-XXXX" v-validate="{ required: true, regex: model.phoneComplexity.phonePattern, min: model.phoneComplexity.phoneMinimumLength, max: model.phoneComplexity.phoneMaximumLength }" autocomplete="off" v-bind:class="{ 'input-validation-error': hasErrorOn('phoneNo') }" :maxlength="15"/>
              <span class="field-validation-error" v-show="hasErrorOn('phoneNo')">{{ errors.first('phoneNo') }}</span>
            </div>
          </div>
          <div class="content-panel-row">
            <label>
              <span class="item label">{{ $t('identityProvider:login:setupOTPpreferredNotificationMethod') }}</span>
            </label>
            <div class="form-group">
              <label class="displayInline">
                <input type="radio" name="preferredNotificationMethod" id="smsPerferredNotifyMethod" class="mr-1" value="sms" checked="checked" />
                {{ $t('identityProvider:login:setupOTPReceiveText') }}
              </label>
            </div>
            <div class="form-group">
              <label class="displayInline">
                <input type="radio" name="preferredNotificationMethod" id="callPerferredNotifyMethod" class="mr-1" value="ivr" />
                {{ $t('identityProvider:login:setupOTPReceiveCall') }}
              </label>
            </div>
          </div>
          <div class="form-actions">
            <button type="submit" class="button" :disabled="disabled">{{$t('shared:action:continue')}}</button>
            <a v-on:click="loginCancel(cancelLink)" class="button-secondary contextual-link" :data-test-element="'security-question-cancel'">{{ $t('shared:action:cancel') }}</a>
          </div>
        </fieldset>
      </div>
    </form>
  </div>
</template>
<script>
  import validation from 'utils/validation-mixin';
  import redirectHandler from 'utils/redirect';
  import Vue from 'vue';
  import ContextualHelp from 'components/popper-help';
  import $ from 'jquery';

  Vue.component('contextual-help-component', ContextualHelp);

  export default {
    mixins: [
      validation
    ],

    props: {
      formAction: {
        default: "authentication/setupphone",
        type: String
      },
      cancelLink: {
        default: "authentication/logincancel",
        type: String
      },
    },

    data: () => ({
      model: {},
      insertmodel: {
        id: null,
        phoneNumber: null,
        countryCodeID: null,
        nickName: null,
        isDefault: false,
        defaultDeliveryMethod: null
      },
      countryCodeID: null,
      countryCode: null,
      phoneNumber: null,
      phoneId: null,
      action: null
    }),

    methods: {
      validateBeforeSubmit() {
        this.$validator.reset()
          .then(_ => {
            this.$validator.validateAll().then(result => {
              if (result) {
                this.post();
              }
            });
          });
      },

      returnCountryCodeAndCountryName(code, name) {
        var len = code.toString().length;
        var result = "+" + code + "<pre>";
        for (var i = len; i < 7; i++) {
          result += "&nbsp;&nbsp;";
        }
        var countryCodeOption = result + "</pre>" + name;
        return countryCodeOption;
      },

      isEmptyorNull(value) {
        return (value == "undefined" || value == null || value == "")
      },

      disabledSMSPreferredNotificationMethod() {
        var value = $("input[name='phoneNumber']:checked").attr('data-forsms');
        var disabled = value != "true" ? true : false;
        $("#smsPerferredNotifyMethod").attr("disabled", disabled);
        if (disabled) {
          $("#callPerferredNotifyMethod").prop("checked", true);
        } else {
          $("#smsPerferredNotifyMethod").prop("checked", true);
        }
      },

      ddlBindPhoneNumber() {
        $("#ddlCountryCode").attr("disabled", true);
        $("#txtPhoneNumber").val('').attr("disabled", true);
        if (this.formAction.indexOf("setupphone") == -1) {
          this.disabledSMSPreferredNotificationMethod();
        }
      },

      txtBindPhoneNumber() {
        $("#ddlCountryCode").removeAttr('disabled');
        $("#txtPhoneNumber").removeAttr('disabled');
        $("#smsPerferredNotifyMethod").attr("disabled", false);
        $("#smsPerferredNotifyMethod").prop("checked", true);
      },

      async post() {
        try {
          var countryCodeIDAttr = $("input[name='phoneNumber']:checked").attr('id');
          var countryCodeAttr = $("input[name='phoneNumber']:checked").attr('data-id');
          var phoneIdAttr = $("input[name='phoneNumber']:checked").attr('data-pid');
          
          if ($("#addnewradio").prop("checked")) {
            this.countryCodeID = $("#ddlCountryCode option:selected").val();
            this.countryCode = $("#ddlCountryCode option:selected").attr('data-id');
            this.phoneNumber = $("#txtPhoneNumber").val();
          }

          if (this.isEmptyorNull(this.phoneNumber)) {
            this.phoneNumber = $("input[name='phoneNumber']:checked").val();
          }

          if (this.isEmptyorNull(this.countryCodeID)) {
            this.countryCodeID = countryCodeIDAttr;
            this.countryCode = countryCodeAttr;
            this.phoneId = phoneIdAttr;
          }
          this.insertmodel.countryCodeID = parseInt(this.countryCodeID);
          this.insertmodel.countryCode = parseInt(this.countryCode);
          this.insertmodel.id = this.phoneId;
          this.insertmodel.phoneNumber = this.phoneNumber.replace(/[_\W]+/g, "");
          this.insertmodel.defaultDeliveryMethod = $("input[name='preferredNotificationMethod']:checked").val();

          let response = await this.$http.post(this.action, this.insertmodel);
          this.model = response.data;
          if (!response.data.showError) {
            redirectHandler.checkAndRedirect(response, this.$router);
          }
        } catch (error) {
          let form = this.$refs.form;
          if (this.validateResponse(form, error.response)) {
            return;
          }
          throw error;
        } finally {
        }
      },

      async loginCancel(path) {
        let response = await this.$http.post(path);
        redirectHandler.checkAndRedirect(response, this.$router);
      }
    },

    async created() {
      try {
        this.action = this.formAction;
        let response = await this.$http.get(this.action);
        this.model = response.data;
      } catch (error) {
        let form = this.$refs.form;
        if (this.validateResponse(form, error.response)) {
          return;
        }
        throw error;
      }
    },

    async updated() {
      if (this.formAction.indexOf("setupphone") == -1) {
        this.disabledSMSPreferredNotificationMethod();
      }
    }
  };
</script>